const buildSolutionsMarkup = () => {
    const megaSolutions = $('.mega-solutions');
    megaSolutions
      .find('.mega-sub-menu .mega-sub-menu')
      .removeAttr('class')
      .wrap("<div class='product-list'><ul class='has-products'></ul></div>");
    megaSolutions
      .find('> .mega-sub-menu')
      .wrapInner(
        "<li><div class='mega-menu-solutions'><ul class='taxonomy-list'></ul></div></li>",
      );
    megaSolutions
      .find('.mega-menu-solutions li.mega-menu-item')
      .removeAttr('class');
    megaSolutions
      .find('.mega-menu-solutions a.mega-menu-link')
      .removeAttr('class');
    return true;
};

// eslint-disable-next-line no-unused-vars
(($) => {
    buildSolutionsMarkup();
})(jQuery);
